import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ReactPaginate from 'react-paginate';


import Filter from '@common-components/filter/Filter';
import Table from '@common-components/table/Table';
import AlertMessage from '../individualPortal/dashboard/AlertMsgs/AlertMessage';
import { ALL_USER_ROLES, USER_GROUPS } from '@constants/roles/userRoleTypes';
import { DELEGATION_HEADER_TYPES, labelNames, filterInputsMaxLength, filterInputsMaxLength_CA, DELEGATION_ALERT_MSGS } from '@constants/delegation/delegationConfig';


// Note paragraph available only for CSR group and Consumer.
const Note = ({ roleGroup }) => (
    (roleGroup === USER_GROUPS.CSR_GROUP || roleGroup === ALL_USER_ROLES.INDIVIDUAL) &&
    <div className="delegation__note">
        <p>
            <FormattedMessage 
                id="delegation_note_text"
                values={{ 
                    note: <b><FormattedMessage id="delegation_note"/></b>, 
                    strong: chunks => <strong>{chunks}</strong>
                }}
            />
        </p>
    </div>
);

// Back to admin link available only for CSR group
const BackToAdminSearch = ({ roleGroup, link }) => (
    roleGroup === USER_GROUPS.CSR_GROUP &&
    <a href={link}
        className="delegation__back-link"
    >
        <span style={{ 'marginRight': '5px' }}>
            <FontAwesomeIcon icon="angle-left"/>
        </span>
        <span><FormattedMessage id="delegation_back"/></span>
    </a>
);

const DelegationView = props => {
    
    const {
        isState,
        roleGroup,
        filters,
        spinner,
        pagination,
        tableData,
        tableColumns,
        onChangeHandler,
        onResetHandler,
        onApplyHandler,
        pageNumber,
        onPageNumberChange,
        backToAdminLink
    } = props;

    return (
        <Fragment>
            { backToAdminLink && <BackToAdminSearch roleGroup={roleGroup} link={backToAdminLink}/> }
            <h2 className="delegation__header"><FormattedMessage id={DELEGATION_HEADER_TYPES[roleGroup]}/></h2>
            <div className="gi-panel">
                <h4 className="delegation__filter-header"><FormattedMessage id="delegation_filter"/></h4>
                <Note roleGroup={roleGroup}/>

                {
                    filters && Object.keys(filters).length > 0 &&
                <Filter
                    filterList={filters}
                    filterInputsMaxLength={isState.CA ? filterInputsMaxLength_CA : filterInputsMaxLength}
                    labelNames={labelNames}
                    formName='filterForm'
                    handleChange={onChangeHandler}
                    resetHandler={onResetHandler}
                    applyHandler={onApplyHandler}
                />
                }
            </div>
            <div className="gi-panel">
                {
                    spinner && spinner.activeSpinnersQty > 0 ? <FormattedMessage id='spinner.loading_data' tagName='div'/>
                        : tableData && tableData.length > 0 ?
                            <Table
                                data={tableData}
                                columns={tableColumns}
                            /> :
                            <AlertMessage
                                content={
                                    <FormattedMessage id={[ALL_USER_ROLES.BROKER, ALL_USER_ROLES.ASSISTER].includes(roleGroup) ?
                                        DELEGATION_ALERT_MSGS.CASE_ID :
                                        DELEGATION_ALERT_MSGS.DEFAULT}/>
                                }
                                type="info"
                            />
                }
            </div>
            {
                pagination && pagination.count > 10 &&
            <ReactPaginate
                previousLabel={<FormattedMessage id="delegation_pagination_prev"/>}
                nextLabel={<FormattedMessage id="delegation_pagination_next"/>}
                breakLabel={'...'}
                breakClassName={'break-me'}
                previousClassName={'pagination_prev'}
                nextClassName={'pagination_next'}
                pageCount={Math.ceil(pagination.count / 10)}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={onPageNumberChange}
                containerClassName={'pagination'}
                subContainerClassName={'pages pagination'}
                activeClassName={'active'}
                forcePage={pageNumber}
                hrefBuilder={() => {
                    return '#';
                }}
            />
            }
        </Fragment>
    );
};

export default DelegationView;